import AddIcon from '@mui/icons-material/Add';
import classNames from 'classnames';
import React from 'react';
import { Button } from 'components/Button/Button';
import { CircledCustomIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import style from './EmptyListArea.scss';

type Props = {
  onAddPress?: () => void;
  buttonText?: string;
  title: string;
  description: string;
  icon: React.FC;
  isButtonVisible?: boolean;
  containerStyle?: string;
  isSmallVersion?: boolean;
};

export const EmptyListArea: React.FC<Props> = ({ title, description, icon, buttonText, onAddPress, containerStyle, isButtonVisible = true, isSmallVersion = false }) => {
  return (
    <div className={classNames(style.container, isSmallVersion && style.smallContainer, containerStyle)}>
      {isSmallVersion ? <CircledCustomIcon icon={icon} containerStyle={style.smallIconContainer} width={20} height={20} /> : <CircledCustomIcon icon={icon} />}
      <div className={classNames(style.textWrapper, isSmallVersion && style.smallTextWrapper)}>
        <Text variant={isSmallVersion ? '2xl' : 'h5'}>{title}</Text>
        <Text variant="md" className={style.description}>
          {description}
        </Text>
      </div>
      {isButtonVisible && (
        <Button variant="contained" onClick={onAddPress} startIcon={<AddIcon />}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};
